import { FrameColorType } from "./types";

export enum AspectRatios {
  xxWide = 2.3333333333333335,
  tall = 0.8,
}

export const posterSizesMapper = {
  SIZE21x30: "21x30 cm",
  SIZE30x40: "30x40 cm",
  SIZE50x50: "50x50 cm",
  SIZE50x70: "50x70 cm",
  SIZE61x91: "61x91 cm",
  SIZE70x100: "70x100 cm",
};

export const PricePerSizeEnum = {
  SIZE21x30: "21x30 cm",
  SIZE30x40: "30x40 cm",
  SIZE50x50: "50x50 cm",
  SIZE50x70: "50x70 cm",
  SIZE61x91: "61x91 cm",
  SIZE70x100: "70x100 cm",
};

export const FrameColorNameMap = {
  us: {
    black: "Black",
    darkWood: "Dark Wood",
    wood: "Wood",
    white: "White",
  },
  se: {
    black: "Svart",
    darkWood: "Mörkt trä",
    wood: "Trä",
    white: "Vit",
  },
};
